@if (!isLoading && faqGroups.length > 0) {
	<div class="faq-showcase__filters">
		<div class="faq-showcase__filters-row">
			<div class="faq-showcase__filter-group">
				<eif-custom-select
					[label]="'faqShowcase.product' | translate"
					[options]="productOptions"
					[(ngModel)]="filterProduct"
					(ngModelChange)="onFilterChange()"
					[placeholder]="'faqShowcase.allProducts' | translate"
					[multiple]="true"
					[clearable]="true"
					[fullWidth]="true">
				</eif-custom-select>
			</div>
			<div class="faq-showcase__filter-group">
				<eif-custom-select
					[label]="'faqShowcase.profile' | translate"
					[options]="profileOptions"
					[(ngModel)]="filterProfile"
					(ngModelChange)="onFilterChange()"
					[placeholder]="'faqShowcase.allProfiles' | translate"
					[multiple]="true"
					[clearable]="true"
					[fullWidth]="true">
				</eif-custom-select>
			</div>
			<div class="faq-showcase__filter-group">
				<eif-custom-select
					[label]="'faqShowcase.category' | translate"
					[options]="availableCategories"
					[(ngModel)]="filterCategory"
					(ngModelChange)="onFilterChange()"
					[placeholder]="'faqShowcase.allCategories' | translate"
					[multiple]="true"
					[clearable]="true"
					[fullWidth]="true">
				</eif-custom-select>
			</div>
			<div class="faq-showcase__filter-group">
				<eif-custom-input
					[label]="'faqShowcase.search' | translate"
					[(ngModel)]="filterSearch"
					(ngModelChange)="onFilterChange()"
					[placeholder]="'faqShowcase.searchPlaceholder' | translate"
					[fullWidth]="false">
				</eif-custom-input>
			</div>
		</div>

		@if (hasActiveFilters()) {
			<div class="faq-showcase__filter-group faq-showcase__filter-group--clear">
				<eif-custom-button
					[text]="'faqShowcase.clearFilters' | translate"
					[color]="'neutral'"
					[variant]="'outlined'"
					[preIcon]="'fa-solid fa-times'"
					(action)="clearFilters()">
				</eif-custom-button>
			</div>
		}
	</div>
}

@if (isLoading) {
	<div class="faq-showcase__loading">
		<i class="fa-regular fa-loader fa-spin mb-2"></i>
		<span>{{ 'faqShowcase.loading' | translate }}</span>
	</div>
}

@if (!isLoading && faqGroups.length === 0) {
	<div class="faq-showcase__empty">
		<i class="fa-regular fa-crate-empty mb-2"></i>
		<p>{{ 'faqShowcase.noFAQsAvailable' | translate }}</p>
	</div>
}

@if (!isLoading && filteredFaqGroups.length > 0) {
	<div class="faq-showcase__content">
		@for (group of filteredFaqGroups; track $index; let i = $index) {
			<div
				class="faq-showcase__group"
				[class.faq-showcase__group--expanded]="group.isExpanded">
				<div
					class="faq-showcase__group-header"
					(click)="toggleGroup(group, $event)">
					<div class="faq-showcase__group-header-content">
						<i class="fa-regular fa-arrow-right fa-xs faq-showcase__group-icon"></i>
						<h3 class="faq-showcase__group-title">{{ group.product }} {{ group.profile }}</h3>
					</div>
					<span class="faq-showcase__group-chevron"></span>
				</div>
				<div
					class="faq-showcase__group-content"
					[class.faq-showcase__group-content--expanded]="group.isExpanded">
					@for (categoryGroup of group.categories; track $index; let j = $index) {
						<div
							class="faq-showcase__category"
							[class.faq-showcase__category--expanded]="categoryGroup.isExpanded">
							<div
								class="faq-showcase__category-header"
								(click)="toggleCategory(categoryGroup, $event)">
								<div class="faq-showcase__category-header-content">
									<i class="fa-solid fa-folder fa-xs faq-showcase__category-icon"></i>
									<h4 class="faq-showcase__category-title">{{ categoryGroup.category.CategoryCodeText }}</h4>
								</div>
								<span class="faq-showcase__category-chevron"></span>
							</div>
							<div
								class="faq-showcase__category-content"
								[class.faq-showcase__category-content--expanded]="categoryGroup.isExpanded">
								@if (categoryGroup.accordionItems && categoryGroup.accordionItems.length > 0) {
									<eif-custom-accordion
										[items]="categoryGroup.accordionItems"
										[allowMultiple]="true"
										[noAccentBorder]="true">
									</eif-custom-accordion>
								}
							</div>
						</div>
					}
				</div>
			</div>
		}
	</div>
}

@if (!isLoading && faqGroups.length > 0 && filteredFaqGroups.length === 0) {
	<div class="faq-showcase__empty">
		<i class="fa-regular fa-crate-empty mb-2"></i>
		<p>{{ 'faqShowcase.noFAQsMatchFilters' | translate }}</p>
	</div>
}
